import type { SubprocessOption } from "../select/SubprocessCells";

// Единствен редослед на подпроцеси за секој приказ на Log Book: Размерување прво, потоа по
// редот на процесот, па по редот на подпроцесот, па по име. Порано секој приказ се потпираше
// на редоследот на снимање, па Пакување можеше да излезе пред Припрема, а подпроцес без
// машина завршуваше на дното. Оваа функција е ЕДИНСТВЕНАТА дефиниција на тој редослед —
// `buildSubprocessSummaryRows` и двете „Вкупно Log Book" табели ја викаат неа, за да не може
// повторно да се разидат.
export function buildSubprocessOrderIndex(
  subprocesses: SubprocessOption[],
  razmerStageId: string
): Map<string, number> {
  const ordered = [...subprocesses]
    .map((sp) => {
      const processDefinition = typeof sp.processDefinition === "object" ? sp.processDefinition : null;
      return {
        id: sp._id,
        processOrder: processDefinition?.order ?? Number.MAX_SAFE_INTEGER,
        subprocessOrder: sp.order ?? Number.MAX_SAFE_INTEGER,
        name: sp.name || "",
      };
    })
    .sort((a, b) => {
      if (a.processOrder !== b.processOrder) return a.processOrder - b.processOrder;
      if (a.subprocessOrder !== b.subprocessOrder) return a.subprocessOrder - b.subprocessOrder;
      return a.name.localeCompare(b.name, "mk");
    });
  const index = new Map<string, number>([[razmerStageId, -1]]);
  ordered.forEach((entry, position) => index.set(entry.id, position));
  return index;
}
